module.exports = __webpack_public_path__ + "img/right.c11287cc.svg";